import type { ParseKeys } from "i18next"
import { useTranslation } from "react-i18next"

import { NavigationCard } from "@/components/shared/navigation-card"

import {
  useWorkspaceDefinition,
  workspaceLinks,
  type Workspace,
} from "./definition"

// A workspace's destinations as navigation cards, in order. A destination
// with no route yet keeps its card, linking nowhere.
export function WorkspaceLinkCards({
  workspace: { ownerType, ownerId },
}: {
  workspace: Workspace
}) {
  const definition = useWorkspaceDefinition(ownerType)
  const { t } = useTranslation(definition.namespaces)

  return workspaceLinks(definition, ownerId).map((link) => (
    <NavigationCard
      key={link.key}
      href={link.href ?? ""}
      title={t(link.titleKey as ParseKeys)}
      description={t(link.descriptionKey as ParseKeys)}
      Icon={link.icon}
    />
  ))
}
